import { AxiosResponse } from 'axios';
import { logResponse } from './log';
import { updateNetworkStatus } from './network-status';

export const axiosResponseFulfilledInterceptor = (
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  response: AxiosResponse<any, any>
) => {
  updateNetworkStatus();
  logResponse(response);
  return response;
};
